var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (typeof _vm.value !== 'undefined')?_c('p',{staticClass:"bg-red-600 px-1 text-white"},[_vm._v(_vm._s(_vm.value[0]))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }